// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage__RX9iw","title":"title__dxcFc","errorImg":"errorImg__1frZ2","btnLink":"btnLink__FzCkV","descriptionBlock":"descriptionBlock__H5ZcK"};